import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hyphenate'
})
export class HyphenatePipe implements PipeTransform {
  /**
   * Replaces a word in the input string with its hyphenated equivalent from an internal dictionary,
   * sets possible hyphenation point in a word
   *
   * - Applies only to exact, case-sensitive word matches.
   * - Intended for use after the translation pipe, to preserve localization keys.
   * - Non-string values are returned as-is (or as empty string if null/undefined).
   *
   * Example:
   *   {{ myValue | translate | hyphenate }}
   *
   * Will replace words like "utstedelsesdato" with "utstedelses\u00ADdato"
   * (the "soft hyphen" symbol between "utstedelses" and "dato") if present in the dictionary.
   */

  private readonly dictionary: Record<string, string> = {
    management: 'manage\u00ADment',
    bestillingsløsning: 'bestillings\u00ADløsning',
    bestillingsløysing: 'bestillings\u00ADløysing',
    Enhetsregisteret: 'Enhets\u00ADregisteret',
    anleggsbransjen: 'anleggs\u00ADbransjen',
    Renholdsbransjen: 'Renholds\u00ADbransjen',
    Reinhaldsbransjen: 'Reinhalds\u00ADbransjen',
    Bilpleiebransjen: 'Bilpleie\u00ADbransjen',
    Varetransportbransjen: 'Vare\u00ADtransport\u00ADbransjen',
    Organisasjonsnummer: 'Organisasjons\u00ADnummer',
    organisasjonsnummer: 'organisasjons\u00ADnummer',
    Driftsmeldinger: 'Drifts\u00ADmeldinger',
    Driftsmeldingar: 'Drifts\u00ADmeldingar',
    informasjonskapsler: 'informa\u00ADsjons\u00ADkapsler',
    informasjonskapslar: 'informa\u00ADsjons\u00ADkapslar',
    Administrasjon: 'Admini\u00ADstrasjon',
    Administration: 'Admini\u00ADstration',
    utstedelsesdato: 'utstedelses\u00ADdato',
    utferdingsdato: 'utferdings\u00ADdato',
    Kundestøtte: 'Kunde\u00ADstøtte',
    Tilgjengelighetserklæring: 'Tilgjengelighets\u00ADerklæring',
    Tilgjengelegheitserklæring: 'Tilgjengelegheits\u00ADerklæring'
  };

  transform(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value !== 'string') {
      return String(value);
    }

    return value.replace(/\b[\wæøåÆØÅ]+\b/g, word => {
      return this.dictionary[word] ?? word;
    });
  }
}
